module.exports = __webpack_public_path__ + "static/4-1920x1440-f34f0826b6440ca75ed946b0001cef1f.jpg";